import React from "react"
import { Col, Row } from "reactstrap"
import { useHistory } from "react-router-dom"

import { AllTrailers } from "./AllTrailers"
import { useUserRole } from "hooks/useUserRole"
import { APP_ROUTES } from "helpers/routeHelpers"
import TabRoute from "components/TabRoutes/TabRoute"
import { Header } from "pages/AdminApp/Common/Header"
import { ProductionSchedule } from "./ProductionSchedule"
import { ConfiguratorOrders } from "./ConfiguratorOrders"
import ConfiguratorOrderDetails from "./ConfiguratorOrders/ConfiguratorOrderDetails"

import activeProduction from "../../assets/images/icons/Vector.png"
import allTrailersActiveIcon from "../../assets/images/icons/Union.png"
import inactiveProduction from "../../assets/images/icons/Vector-disbale.png"
import allTrailersInactiveIcon from "../../assets/images/icons/Union-disable.png"
import activeConfiguratorOrdersIcon from "assets/images/icons/active-configurator-orders.svg"
import inactiveConfiguratorOrdersIcon from "assets/images/icons/inactive-configurator-orders.svg"

const TABS_KEYS = {
   ConfiguratorOrders: "configuratorOrders",
   ConfiguratorOrderDetails: "configuratorOrderDetails",
   AllOrdersTab: "allOrders",
   ProductionScheduleTab: "productionSchedule",
}
const TABS_NAME = {
   ConfiguratorOrders: "Configurator Orders",
   ConfiguratorOrderDetails: "Configurator Order Details",
   AllOrders: "All Orders",
   ProductionSchedule: "Production Schedule",
}

const ROUTES_CONFIG = [
   {
      name: TABS_NAME.ConfiguratorOrders,
      exact: true,
      component: ConfiguratorOrders,
      path: APP_ROUTES.TIMELINE_CONFIGURATOR_ORDERS,
   },
   {
      name: TABS_NAME.ConfiguratorOrderDetails,
      exact: true,
      component: ConfiguratorOrderDetails,
      path: APP_ROUTES.TIMELINE_CONFIGURATOR_ORDER_DETAILS,
   },
   {
      name: TABS_NAME.AllOrders,
      exact: true,
      component: AllTrailers,
      path: APP_ROUTES.TIMELINE_ALL_ORDERS,
   },
   {
      name: TABS_NAME.ProductionSchedule,
      exact: true,
      component: ProductionSchedule,
      path: APP_ROUTES.TIMELINE_PRODUCTION_SCHEDULE,
   },
]

const TABS_CONFIG = [
   {
      title: TABS_NAME.ConfiguratorOrders,
      identifier: TABS_KEYS.ConfiguratorOrders,
      icon: inactiveConfiguratorOrdersIcon,
      activeIcon: activeConfiguratorOrdersIcon,
      path: APP_ROUTES.TIMELINE_CONFIGURATOR_ORDERS,
   },
   {
      title: TABS_NAME.AllOrders,
      identifier: TABS_KEYS.AllOrdersTab,
      icon: allTrailersInactiveIcon,
      activeIcon: allTrailersActiveIcon,
      path: APP_ROUTES.TIMELINE_ALL_ORDERS,
   },
   {
      title: TABS_NAME.ProductionSchedule,
      identifier: TABS_KEYS.ProductionScheduleTab,
      icon: inactiveProduction,
      activeIcon: activeProduction,
      path: APP_ROUTES.TIMELINE_PRODUCTION_SCHEDULE,
   },
]

const TimelineManagement = () => {
   const history = useHistory()

   const { isPlantManager, isAssistantPlantManager } = useUserRole()

   const isAllOrdersTabHide = isPlantManager || isAssistantPlantManager

   const filteredTabs = isAllOrdersTabHide
      ? TABS_CONFIG.filter(tab => tab.identifier !== TABS_KEYS.AllOrdersTab)
      : TABS_CONFIG
   return (
      <>
         <Row>
            <Col className="col-12">
               <Header
                  headerTitle="Timeline"
                  btnTitle="Create Order / Add Trailer"
                  showButton={false}
                  showButtonSearch={false}
                  headerBtnResponsive="ad-header-btn-responsive"
                  searchResponsiveness="admin-user-mangement-search-responsiveness"
                  flexResponsive="ad-user-mangement"
                  flexResponsiveInner="ad-user-management-inner"
                  SearchBoxContainer="ad-search-box-container"
               />
            </Col>
         </Row>

         <TabRoute tabConfig={filteredTabs} routesConfig={ROUTES_CONFIG} />
      </>
   )
}

export default TimelineManagement
